<template>
  <div class="benefits-wrap">

    <!-- ── Top Benefits ── -->
    <p class="benefits-section-label">Top Benefits</p>
    <div class="top-benefits-grid">

      <div class="top-benefit-tile">
        <div class="tbt-icon-wrap">
          <img src="/images/icons/tow.png" alt="towing" class="tbt-img" />
        </div>
        <span class="tbt-name">Towing</span>
        <span class="tbt-limit">Free Limit KSH 30,000</span>
      </div>

      <div class="top-benefit-tile">
        <div class="tbt-icon-wrap">
          <img src="/images/icons/radio.png" alt="entertainment" class="tbt-img" />
        </div>
        <span class="tbt-name">Entertainment</span>
        <span class="tbt-limit">Free Standard Limit KSH 30,000</span>
      </div>

      <div class="top-benefit-tile">
        <div class="tbt-icon-wrap">
          <img src="/images/icons/screen.png" alt="windscreen" class="tbt-img" />
        </div>
        <span class="tbt-name">Windscreen</span>
        <span class="tbt-limit">Free Standard Limit KSH 30,000</span>
      </div>

      <div class="top-benefit-tile">
        <div class="tbt-icon-wrap">
          <img src="/images/icons/setting.png" alt="damages repair" class="tbt-img" />
        </div>
        <span class="tbt-name">Damages Repair</span>
        <span class="tbt-limit">Free Limit KSH 30,000</span>
      </div>

    </div>

    <!-- ── Other Benefits ── -->
    <p class="benefits-section-label">Other Benefits</p>
    <div class="other-benefits-grid">

      <div class="obl-row">
        <div class="obl-icon-wrap obl-bg-navy">
          <img src="/images/icons/harm.png" alt="legal defence" class="obl-img" />
        </div>
        <div class="obl-body">
          <span class="obl-name">Legal defence</span>
          <span class="obl-limit">Free limit KSH 10,000</span>
        </div>
      </div>

      <div class="obl-row">
        <div class="obl-icon-wrap obl-bg-sky">
          <img src="/images/icons/cross.png" alt="medical expenses" class="obl-img" />
        </div>
        <div class="obl-body">
          <span class="obl-name">Medical expenses</span>
          <span class="obl-limit">Free limit KSH 30,000</span>
        </div>
      </div>

      <div class="obl-row">
        <div class="obl-icon-wrap obl-bg-navy">
          <img src="/images/icons/car1.png" alt="third party person liability" class="obl-img" />
        </div>
        <div class="obl-body">
          <span class="obl-name">Third party person liability</span>
          <span class="obl-limit">Free limit; Any Person KSH 3,000,000 / Any One Event KSH 5,000,000</span>
        </div>
      </div>

      <div class="obl-row">
        <div class="obl-icon-wrap obl-bg-sky">
          <img src="/images/icons/car3.png" alt="passengers liability" class="obl-img" />
        </div>
        <div class="obl-body">
          <span class="obl-name">Passengers liability</span>
          <span class="obl-limit">Free limit; Any Person KSH 3,000,000 / Any One Event KES 20,000,000</span>
        </div>
      </div>

      <div class="obl-row obl-row--full">
        <div class="obl-icon-wrap obl-bg-red">
          <img src="/images/icons/hit.png" alt="third party property damage" class="obl-img" />
        </div>
        <div class="obl-body">
          <span class="obl-name">Third party property damage</span>
          <span class="obl-limit">Free limit KSH 5,000,000</span>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'Benefits',
};
</script>

<style scoped>
.benefits-wrap {
  padding: 4px 0 8px;
}

.benefits-section-label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #00AEEF;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 10px;
}

.top-benefits-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 18px;
}

.top-benefit-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: #F8FBFF;
  border: 1px solid #DEE9F5;
  border-radius: 10px;
  padding: 14px 8px 12px;
  gap: 5px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.top-benefit-tile:hover {
  border-color: #00AEEF;
  box-shadow: 0 2px 8px rgba(0, 174, 239, 0.12);
}

.tbt-icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: white;
  border: 1.5px solid #DEE9F5;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(30, 66, 118, 0.08);
  margin-bottom: 4px;
  flex-shrink: 0;
}

.tbt-img {
  width: 26px;
  height: 26px;
  object-fit: contain;
}

.tbt-name {
  font-size: 0.74rem;
  font-weight: 700;
  color: #00AEEF;
  line-height: 1.2;
}

.tbt-limit {
  font-size: 0.65rem;
  color: #1E4276;
  font-weight: 600;
  line-height: 1.4;
}

.other-benefits-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.obl-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  background: white;
  border: 1px solid #E8EDF2;
  border-radius: 8px;
  transition: border-color 0.15s;
}

.obl-row:hover {
  border-color: #b3e5f9;
}

.obl-row--full {
  grid-column: 1 / -1;
}

.obl-icon-wrap {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.obl-bg-navy { background: #EAF0F6; }
.obl-bg-sky  { background: #EBF8FF; }
.obl-bg-red  { background: #FFF5F5; }

.obl-img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}

.obl-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.obl-name {
  font-size: 0.77rem;
  font-weight: 700;
  color: #1E4276;
  line-height: 1.3;
}

.obl-limit {
  font-size: 0.68rem;
  color: #00AEEF;
  font-weight: 600;
  line-height: 1.4;
}

@media (max-width: 600px) {
  .top-benefits-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .other-benefits-grid {
    grid-template-columns: 1fr;
  }
  .obl-row--full {
    grid-column: auto;
  }
}
</style>
